/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import type {CheckboxChangeEvent, CheckboxProps } from 'antd/es/checkbox';
import classNames from 'classnames';

type Props = {
    wrapperClassName?: string
    error?: string;
    label?: ReactNode | string;
    onToggle?: (checked: boolean) => void;
    checkboxClassName?: string;
    checkboxLabelClassName?: string;
} & CheckboxProps;

const OnahCheckBox: React.FC<Props> = ({
  className, name, wrapperClassName, 
  error, label, value, onToggle, onChange, 
  checkboxClassName, checkboxLabelClassName, ...props}) => {
  const [checked, setChecked] = useState(!!value);

  useEffect(() => {
    onToggle && onToggle(!!value)
    setChecked(!!value);
  }, [value])

  const handleChange = (e: CheckboxChangeEvent) => {
    setChecked(e.target.checked);
    onChange && onChange(e)
    onToggle && onToggle(e.target.checked)
  };

  return (
    <div className={wrapperClassName} >
      <label htmlFor={name} className={classNames(className, 'space-x-2 flex items-center')}>
        <div>
          <Checkbox
            {...props}
            checked={checked}
            onChange={e => handleChange(e)}
            name={name}
            className={classNames(
              checkboxClassName,
              !!error ? 'checkbox-error' : '', 
            '[&>.ant-checkbox>.ant-checkbox-inner]:w-[20px] [&>.ant-checkbox>.ant-checkbox-inner]:h-[20px]',
            '[&.ant-checkbox-wrapper]:w-[20px] [&.ant-checkbox-wrapper]:h-[20px]',
            )}
          />
        </div>
        {typeof label === 'string' ? <span className={classNames("text-[14px] font-medium font-sans text-gray-subTextHint", checkboxLabelClassName)}>{label}</span> : label}
      </label>
    </div>
  );
};

export default OnahCheckBox;